<div class="hidden-sm hidden-md hidden-lg ">
  <app-nav ></app-nav>
</div>
<div class="visible-lg">
<app-headerhome ></app-headerhome>
</div>
<div class="container _mt-50 bg-buupass">
</div>

<div class="theme-page-section _p-20 _mt-50 ">
<!-- Main Account Section -->
<div class="container py-4">
  <div class="row justify-content-center">
    <!-- Sidebar -->
    <div class="col-md-4 col-lg-3 mb-4">
      <app-account-header
        [activeTab]="activeTab"
        (scrollToSection)="scrollTo($event)">
      </app-account-header>
    </div>

    <!-- Content -->
    <div class="col-md-10 col-lg-8">

      <!-- Profile Completion -->
      <div class="card p-4 rounded-3 shadow-sm mb-4">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0 buupass-text">Complete your Profile</h5>
          <span class="fw-semibold" [ngClass]="{
            'text-danger': profileCompletion <= 30,
            'text-warning': profileCompletion > 30 && profileCompletion < 70,
            'text-success': profileCompletion >= 70
          }">
            {{ profileCompletion }}%
          </span>
        </div>
        
        <p class="text-muted mt-2 mb-3">
          Get the best out of Buupass by adding the remaining details!
        </p>
        <div class="progress mb-3" style="height: 8px;">
          <div
            class="progress-bar"
            role="progressbar"
            [style.width.%]="profileCompletion"
            [style.backgroundColor]="
              profileCompletion < 40 ? '#D50000' : (profileCompletion < 70 ? '#FFC107' : '#28a745')
            ">
          </div>
        </div>
        
        <div class="d-flex flex-wrap gap-3">
          <ng-container *ngIf="user?.email">
            <button class="btn btn-outline-success btn-sm rounded-pill px-3 button-spacing" >✔ Verified Email ID</button>
          </ng-container>
          <ng-container *ngIf="!user?.email">
            <button class="btn buupass-btn-primary btn-sm rounded-pill px-3 button-spacing" data-toggle="modal" data-target="#buupassEmailModal">+ Add your email ID</button>
          </ng-container>
          <ng-container *ngIf="user?.phone_number">
            <button class="btn btn-outline-success btn-sm rounded-pill px-3 button-spacing" >✔ Verified Mobile Number</button>
          </ng-container>
          <ng-container *ngIf="!user?.phone_number">
            <button class="btn buupass-btn-primary btn-sm rounded-pill px-3 button-spacing" data-toggle="modal" data-target="#buupassPhoneModal">+ Add your mobile number</button>
          </ng-container>
          <ng-container *ngIf="profileCompletion >= 70; else showCompleteButton">
            <button class="btn btn-outline-success btn-sm rounded-pill px-3 button-spacing" disabled>
              ✔ Basic Info Complete
            </button>
          </ng-container>
          <ng-template #showCompleteButton>
            <button class="btn buupass-btn-primary btn-sm rounded-pill px-3 button-spacing" data-toggle="modal" data-target="#buupassProfileModal"
            >
              + Complete Basic Info
            </button>
          </ng-template>
        </div>
      </div>

              <!-- Profile Info -->
          <div *ngIf="activeTab === 'profile'" class="profile-section">
            <div class="d-flex align-items-center mb-3">
              <div class="me-row">
                <h5 class="section-title">Profile</h5>
                <p class="section-subtitle">Basic info, for a faster booking experience</p>
                <button
                class="buupass-btn-primary btn-sm rounded-pill px-3"
                data-toggle="modal"
                data-target="#buupassProfileModal"
              >
                ✏️ Edit
              </button>
              </div>
              
            </div>
            

          <!-- First Name -->
            <div class="profile-row">
              <span class="text-buupass fw-semibold">First Name</span>
              <ng-container *ngIf="user?.first_name; else addFirstName">
                <span>{{ user.first_name }}</span>
              </ng-container>
              <ng-template #addFirstName>
                <button class="add-btn" data-toggle="modal" data-target="#buupassProfileModal">+ Add</button>
              </ng-template>
            </div>

            <!-- Last Name -->
            <div class="profile-row">
              <span class="text-buupass fw-semibold">Last Name</span>
              <ng-container *ngIf="user?.last_name; else addLastName">
                <span>{{ user.last_name }}</span>
              </ng-container>
              <ng-template #addLastName>
                <button class="add-btn" data-toggle="modal" data-target="#buupassProfileModal">+ Add</button>
              </ng-template>
            </div>

            <!-- ID Number -->
            <div class="profile-row">
              <span class="text-buupass fw-semibold">ID NO</span>
              <ng-container *ngIf="user?.id_number; else addIdNumber">
                <span>{{ user.id_number }}</span>
              </ng-container>
              <ng-template #addIdNumber>
                <button class="add-btn" data-toggle="modal" data-target="#buupassProfileModal">+ Add</button>
              </ng-template>
            </div>

        
          </div>

          <!-- Login Details -->
          <div *ngIf="activeTab === 'login'" class="profile-section">
            <h5 class="section-title">Login Details</h5>
            <p class="section-subtitle">Manage your mobile number, email address and password</p>

            <div class="profile-row">
              <span>Mobile Number</span>
              <span *ngIf="user?.phone_number; else noPhone">
                {{ user.phone_number }} ✅
              </span>
              <ng-template #noPhone>
                <button class="add-btn" data-toggle="modal" data-target="#buupassPhoneModal">
                  + Add your mobile number
                </button>
              </ng-template>
            </div>
            <div class="profile-row">
              <span>Email ID</span>
              <span *ngIf="user?.email; else noEmail">
                {{ user.email }} ✅
              </span>
              <ng-template #noEmail>
                <button class="add-btn" data-toggle="modal" data-target="#buupassEmailModal">
                  + Add your email ID
                </button>
              </ng-template>
            </div>
            <div class="profile-row">
              <span>Password</span>
              <button class="add-btn" data-toggle="modal" data-target="#buupassPasswordModal">Change Password</button>
            </div>
          </div>

          <!-- Co-Travellers -->
          <!-- <div *ngIf="activeTab === 'travellers'" class="profile-section">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h5 class="section-title">Co-Travellers</h5>
              <button class="btn btn-outline-primary btn-sm rounded-pill" (click)="openModal('traveller')">+ Add Traveller</button>
            </div>
            <p class="section-subtitle">Add, remove and update your traveller list</p>
          </div> -->

          <!-- Logged In Devices -->
          <div *ngIf="activeTab === 'devices'" class="profile-section">
            <h5 class="section-title">Logged In Devices</h5>
            <p class="section-subtitle mb-3">Check all the devices where your account is logged in</p>
          
            <div *ngIf="loggedInDevices?.length > 0; else noDevices">
              <div class="card p-3 mb-3" *ngFor="let device of loggedInDevices">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <h6 class="mb-1">{{ device.deviceType }}</h6>
                    <small class="text-muted d-block">{{ device.location }} - {{ device.ipAddress }}</small>
                    <small class="text-muted">Last active: {{ device.lastActive }}</small>
                  </div>
                  <span *ngIf="device.isCurrent" class="badge bg-success text-white rounded-pill">Current Device</span>
                </div>
              </div>
            </div>
          
            <ng-template #noDevices>
              <p class="text-muted">No devices currently logged in.</p>
            </ng-template>
          </div>
          

    </div>
  </div>
</div>
</div>


<!-- Profile Modal -->
<div class="modal fade" id="buupassProfileModal" tabindex="-1" aria-labelledby="profileModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content">
      <form class="modal-content" #profileForm="ngForm">
        <!-- Header -->
        <div class="modal-header">
          <button id="closeProfile" type="button" class="close" data-dismiss="modal">&times;</button>
          <h5 class="modal-title fw-bold">Edit Profile</h5>
        </div>

        <!-- Body -->
        <div class="modal-body p-4">
          <div class="mb-3">
            <label class="form-label">First Name</label>
            <input
              type="text"
              class="form-control"
              name="first_name"
              [(ngModel)]="form.first_name"
              required />
          </div>

          <div class="mb-3">
            <label class="form-label">Last Name</label>
            <input
              type="text"
              class="form-control"
              name="last_name"
              [(ngModel)]="form.last_name"
              required />
          </div>

          <div class="mb-3">
            <label class="form-label">Email</label>
            <input
              type="email"
              class="form-control"
              name="email"
              [(ngModel)]="form.email"
              required />
          </div>

          <div class="mb-3">
            <label class="form-label">ID Number</label>
            <input
              type="text"
              class="form-control"
              name="id_number"
              [(ngModel)]="form.id_number" />
          </div>

          <!-- Password optional -->
          <!-- 
          <div class="mb-3">
            <label class="form-label">Password</label>
            <input
              type="password"
              class="form-control"
              name="password"
              [(ngModel)]="form.password" />
          </div>
          -->
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          
          <button type="button" class="btn btn-primary px-4" (click)="submitProfile()">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>

  <!-- Mobile Number Modal -->
<div class="modal fade" id="buupassPhoneModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <button id="closeProfile" type="button" class="close" data-dismiss="modal">&times;</button>
        <h5 class="modal-title">Add Your Mobile Number</h5>
        <!-- <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button> -->
      </div>
      <div class="modal-body">
        <p class="text-muted">For a faster booking experience, exclusive offers and rewards</p>

        <label class="form-label">Mobile Number</label>
        <div class="input-group ">
          <span class="input-group-text">
            <img src="https://flagcdn.com/16x12/ke.png" alt="KE Flag" class="me-1" />
            +254
          </span>
          <input type="tel"
                 class="form-control"
                 [(ngModel)]="phoneNumber"
                 name="phone"
                 placeholder="eg. 999999999"
                 maxlength="9"
                 pattern="^[0-9]{9}$"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" (click)="submitPhoneNumber()">Submit</button>
      </div>
    </div>
  </div>
</div>


<!-- Change Password Modal -->
<div class="modal fade" id="buupassPasswordModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <button id="closeProfile" type="button" class="close" data-dismiss="modal">&times;</button>
        <h5 class="modal-title">Change Password?</h5>
        <!-- <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button> -->
      </div>

      <div class="modal-body">
        <form>
          <!-- Old Password -->
          <div class="mb-3">
            <label class="form-label">Old Password</label>
            <input
              [type]="showOldPassword ? 'text' : 'password'"
              class="form-control"
              [(ngModel)]="passwordForm.oldPassword"
              name="oldPassword"
              placeholder="Enter Old Password"
            />
          </div>

          <!-- New Password -->
          <div class="mb-3 position-relative">
            <label class="form-label">New Password</label>
            <input
              [type]="showNewPassword ? 'text' : 'password'"
              class="form-control"
              [(ngModel)]="passwordForm.newPassword"
              name="newPassword"
              placeholder="Enter New Password"
            />
          </div>

          <!-- Confirm Password -->
          <div class="mb-3 position-relative">
            <label class="form-label">Confirm New Password</label>
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              class="form-control"
              [(ngModel)]="passwordForm.confirmPassword"
              name="confirmPassword"
              placeholder="Confirm New Password"
            />
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="submitPassword()">Submit</button>
      </div>
    </div>
  </div>
</div>

<!-- Add Email Modal -->
<div class="modal fade" id="buupassEmailModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <button id="closeProfile" type="button" class="close" data-dismiss="modal">&times;</button>
        <h5 class="modal-title">Add Your Email ID</h5>
        <!-- Optional close button -->
        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
      </div>

      <div class="modal-body">
        <p class="text-muted">We’ll use this to send you booking confirmations and important updates.</p>

        <label class="form-label">Email ID</label>
        <input
          type="email"
          class="form-control"
          [(ngModel)]="emailInput"
          name="email"
          placeholder="e.g. yourname@example.com"
          required
        />
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="submitEmail()">Save</button>
      </div>
    </div>
  </div>
</div>

